import { API, graphqlOperation } from "aws-amplify";
export class SurveyCoaching {
  constructor(filter) {
    this._filter = filter;
    this._nextToken = null;
    this._graphData = null;
  }

  getGraphData() {
    const that = this;
    return new Promise(async function (resolve) {
      let results = await that.getCoachingSurveyData();
      that._graphData = results;
      while (that._nextToken !== null) {
        let nextResultSet = await that.getCoachingSurveyData();
        that._graphData.push(...nextResultSet);
      }
      resolve(that._graphData);
    });
  }

  async getCoachingSurveyData() {
    const listSurveyCoachings = /* GraphQL */ `
      query ListSurveyCoachings(
        $filter: ModelSurveyCoachingFilterInput
        $limit: Int
        $nextToken: String
      ) {
        listSurveyCoachings(
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          items {
            id
            company
            name
            date
            participants
            isDeleted
            surveyCoachingFeedback {
              items {
                id
                rateCoaching
                benefitted
                connected
                actions
                expectations
                takeaway
                improve
                recommend
                feedback
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          nextToken
        }
      }
    `;
    let gqlConfig = {
      nextToken: this._nextToken,
      limit: 2000,
    };
    if (this._filter) {
      gqlConfig = {
        filter: this._filter,
        nextToken: this._nextToken,
        limit: 2000,
      };
    }

    const { data: { listSurveyCoachings: results } } = await API.graphql(
      graphqlOperation(listSurveyCoachings, gqlConfig)
    );
    this._nextToken = results.nextToken;
    let coachingSessions = [];
    results.items.forEach(function (coaching) {
      coaching.surveyCoachingFeedback.items.map((feedback) => {
        coachingSessions.push({
          company: coaching.company,
          description: coaching.name,
          participants: coaching.participants,
          actions: feedback.actions,
          benefitted: feedback.benefitted,
          connected: feedback.connected,
          expectations: feedback.expectations,
          rateCoaching: feedback.rateCoaching,
          recommend: feedback.recommend,
          feedback: feedback.feedback,
          improve: feedback.improve,
          takeway: feedback.takeaway,
        });
      });
    });
    return coachingSessions;
  }
  async getCoachingSurveyFeedbackData(filter) {
    const listSurveyCoachings = /* GraphQL */ `
      query ListSurveyCoachings(
        $filter: ModelSurveyCoachingFilterInput
        $limit: Int
        $nextToken: String
      ) {
        listSurveyCoachings(
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          items {
            id
            company
            name
            date
            participants
            isDeleted
            createdAt
            updatedAt
          }
          nextToken
        }
      }
    `;
    let gqlConfig = {
      limit: 2000,
    };
    if (filter) {
      gqlConfig = {
        limit: 2000,
        filter: filter,
      };
    }

    const result = await API.graphql(
      graphqlOperation(listSurveyCoachings, gqlConfig)
    );
    return result.data.listSurveyCoachings.items;
  }

  getUniqueCompanyNames() {
    const uniqueColumn = this._graphData.map(function (value) {
      return value.company.trim();
    });
    let uniqueArray = [...new Set(uniqueColumn)];
    return uniqueArray.sort();
  }

  getUniqueCoach() {
    const uniqueColumn = this._graphData.map(function (value) {
      return value.participants.trim();
    });
    let uniqueArray = [...new Set(uniqueColumn)];
    return uniqueArray.sort();
  }

  getUniqueCoachingNames(company) {
    const coachingNames = this._graphData
    .filter(function (value) {
      return value.company.trim().toLowerCase() === company.trim().toLowerCase();
    })
    .map(function (value) {
      if (value.description) {
        return value.description.trim();
      }
    });
    let uniqueArray = [...new Set(coachingNames)];
    return uniqueArray.sort();
  }
}
